import { Injector } from '@angular/core';
import { EMPTY, of, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AppConfig } from '@awp/core/config';
import { isNullOrEmpty } from '@awp/core/utils';
import { SirenHttp, getAction } from '@awp/http';
import { ClientService } from './client.service';
import * as api from '@awp/quote/models';
import { ThemeService } from '@awp/theme';
import { Router } from '@angular/router';
// Note: This service is used by Eligibility Portal
var AuthService1 = /** @class */ (function () {
    function AuthService1(injector, http, router, themeService, clientService) {
        this.injector = injector;
        this.http = http;
        this.router = router;
        this.themeService = themeService;
        this.clientService = clientService;
    }
    Object.defineProperty(AuthService1.prototype, "token", {
        get: function () {
            var result = this._authProperties != null ? this._authProperties.accessToken : null;
            if (isNullOrEmpty(result)) {
                console.log('Token is not defined');
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    AuthService1.prototype.authenticate = function () {
        var _this = this;
        if (this._authResponse != null) {
            return of(this._authResponse);
        }
        var appConfig = this.injector.get(AppConfig);
        var body = this.clientService.getClient();
        if (body != null && typeof body.subscribe === "function") {
            throw Error('Client is not defined');
        }
        var href = appConfig.API_BASE_URL + "/Application/Authenticate";
        return this.http.post({ name: 'Authenticate', href: href }, body)
            .pipe(tap(function (response) {
            if (!response.properties.isAuthenticated) {
                throw new Error('Authentication failed');
            }
            _this._authResponse = response;
            _this._authProperties = response.properties;
        }), catchError(function (error, caught) {
            if (error.error) {
                var stopSellerror = error.error.properties.isStopSell;
                if (stopSellerror) {
                    var tree = _this.router.createUrlTree(['/page/not-found']);
                    _this.router.navigateByUrl(tree, { replaceUrl: true });
                    return EMPTY;
                }
            }
            return throwError(error);
        }));
    };
    AuthService1.prototype.refresh = function () {
        var _this = this;
        var action = getAction(api.ApiAction.ReAuthenticate, this._authResponse);
        var body = {
            accessToken: this._authProperties.accessToken,
            refreshToken: this._authProperties.refreshToken
        };
        return this.http.post(action, body)
            .pipe(tap(function (response) {
            if (response.properties.isAuthenticated) {
                _this._authProperties = response.properties;
            }
        }));
    };
    AuthService1.prototype.setAuthResponse = function (authResponse, reAuthResponse) {
        this._authResponse = authResponse;
        if (reAuthResponse != null) {
            this._authProperties = reAuthResponse.properties;
        }
        else if (authResponse != null) {
            this._authProperties = authResponse.properties;
        }
        else {
            this._authProperties = null;
        }
    };
    return AuthService1;
}());
export { AuthService1 };
